module.exports = __webpack_public_path__ + "img/not_found.f07797b0.svg";